var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgColoredIIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33398 4.72005H8.66732V6.05339H7.33398V4.72005ZM7.33398 7.38672H8.66732V11.3867H7.33398V7.38672ZM8.00065 1.38672C4.32065 1.38672 1.33398 4.37339 1.33398 8.05339C1.33398 11.7334 4.32065 14.7201 8.00065 14.7201C11.6806 14.7201 14.6673 11.7334 14.6673 8.05339C14.6673 4.37339 11.6806 1.38672 8.00065 1.38672ZM8.00065 13.3867C5.06065 13.3867 2.66732 10.9934 2.66732 8.05339C2.66732 5.11339 5.06065 2.72005 8.00065 2.72005C10.9406 2.72005 13.334 5.11339 13.334 8.05339C13.334 10.9934 10.9406 13.3867 8.00065 13.3867Z",
    fill: "url(#paint0_linear_3642_5626)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3642_5626",
    x1: 11.5005,
    y1: 2.59766,
    x2: 4.00049,
    y2: 12.5977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAA945"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497119,
    stopColor: "#ED5944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E22E5C"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColoredIIcon);
export default __webpack_public_path__ + "static/media/colored_i_icon.a02ca4a8da1453a6531a7fd8ce3fe411.svg";
export { ForwardRef as ReactComponent };